module.exports = __webpack_public_path__ + "static/img/1_b_cross.1a4924b1.png";